import React from "react";
import axios from "axios";
import { URL, getAuthorizationHeader } from "../../constans/constants";
import { firmaEmpleado } from './RecibosService';
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { getUsuarioLogueado, getEmpresa, logout } from "../../components/login/SesionService"
import { Container, Form, Modal, Button, InputGroup } from 'react-bootstrap'
import Cookies from 'universal-cookie';
import { createGostCanvasAndGetAppareance, loadSignature } from "../tiposDocumento/AparienciaServicios";
import visibility_white from '../../styles/icons/visibility_white.svg';
import visibility_off from '../../styles/icons/visibility_off.svg';

class PinEmpleado extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idLote: "",
      keystore: 0,
      formatoFirmaEmpleado: "",
      pin: "",
      respuesta: "",
      severity: "success",
      mostrarPantallaCarga: false,
      datosUsuarios: {},
      datosEmpresa: {},
      isFirmaEmpleado: false,
      validated: false,
      isLoaded: false,
      mostrarPassword: false,
      errors: {
        pin: null
      }
    };
    this.dialogRef = React.createRef();
  }

  handleClose = (data) => {
    this.props.handleClose(false, data);
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleFirmasPDF = (tipoFirma, value) => {
    if (tipoFirma == 'EMP')
      this.setState({ isFirmaEmpleado: value })
  };

  validarCamposFormulario = () => {
    let errors = {}
    let isValid = false
    if (this.state.pin === null || this.state.pin.trim() === "") {
      errors = { pin: "Debe ingresar un Pin valido" }
      return { isValid, errors }
    } else
      isValid = true

    return { isValid, errors }
  }

  handlePinSubmit = async (event) => {

    event.preventDefault();
    if (this.state.mostrarPantallaCarga) return;
    const { isValid, errors } = this.validarCamposFormulario()
    if (!isValid) {
      this.setState({ errors: errors })
    } else {
      if (this.state.keystore == 0) {
        this.setState({
          errorPin: true
        })
      } else {
        this.setState({ mostrarPantallaCarga: true });
        try {
          if (this.props.formatoDocumento == "PDF") {
            var formatoEmpleado = await loadSignature(this.state.formatoFirmaEmpleado, this.state.datosUsuarios, this.state.datosEmpresa, false);
            var json = {
              appearance: null,
              keystoreId: this.state.keystore,
              pin: this.state.pin,
              idLote: this.props.idLote,
              idRecibo: this.props.idRecibo
            };
            if (formatoEmpleado.appearance) {
              json = await createGostCanvasAndGetAppareance(formatoEmpleado, json, this.props.estado, this.handleClose, this.handleFirmasPDF);
              await this.firmar(json);
            } else {
              this.setState({ mostrarPantallaCarga: false });
            }
          } else {
            const json = {
              appearance: null,
              keystoreId: this.state.keystore,
              pin: this.state.pin,
              idLote: this.props.idLote,
              idRecibo: this.props.idRecibo
            };
            const response = await firmaEmpleado(json);
            this.setState({ mostrarPantallaCarga: false });
            this.handleClose(response);
          }
        } catch (error) {
          this.setState({ mostrarPantallaCarga: false });
          this.cerrarModal();
          this.props.handleClose(false, {
            error: true,
            mensaje: "Error al firmar el documento"
          });
        }
      }
    }

  };

  firmar = async (json) => {
    if (this.props.estado == 'Pendientes') {
      const response = await firmaEmpleado(json);
      this.setState({ mostrarPantallaCarga: false });
      this.handleClose(response);
      return response;
    }
    this.setState({ mostrarPantallaCarga: false });
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.abrirModal();
      const cookies = new Cookies();
      let token = {
        token: localStorage.getItem("tokenIscert"),
        psa: localStorage.getItem("codigoClienteFirma")
      }
      axios
        .post(URL + "payrolls/iscert/keystore", token, getAuthorizationHeader())
        .then((res) => {
          if (res.data.error == false) {
            this.setState({ keystore: res.data.datos.keystores[0].id, isLoaded: true });
          } else {
            this.cerrarModal(); // Cerrar el dialog
            this.props.handleClose(false, {
              error: true,
              mensaje: res.data.mensaje || "Error al cargar datos de firma"
            });
          }
        }, error => {
          if (error.response?.status === 401) {
            logout();
          }
          return error;
        });
      axios
        .get(
          URL + "lote/getEmpleadoSignFormat/" + this.props.idLote + "/" + cookies.get('username'),
          getAuthorizationHeader()
        )
        .then((res) => {
          if (res.data.error == false)
            this.setState({ formatoFirmaEmpleado: res.data.datos });
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        })
      getUsuarioLogueado().then((response) => {
        this.setState({ datosUsuarios: response });
      });
      getEmpresa().then((response) => {
        this.setState({ datosEmpresa: response })
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Detectar cambios en isOpen para abrir/cerrar el modal
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        this.abrirModal();
      } else {
        this.cerrarModalConAnimacion();
      }
    }
  }

  abrirModal = () => {
    if (this.dialogRef.current && !this.dialogRef.current.open) {
      this.dialogRef.current.showModal();
    }
  }

  cerrarModal = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.close();
    }
  }

  cerrarModalConAnimacion = () => {
    if (this.dialogRef.current && this.dialogRef.current.open) {
      this.dialogRef.current.style.scale = '0';
      setTimeout(() => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
          this.dialogRef.current.close();
        }
      }, 300);
    }
  }

  manejarCancelar = () => {
    this.cerrarModalConAnimacion();
    setTimeout(() => {
      this.props.handleClose(false, null, this.state.tipoFirma);
    }, 300);
  }

  handleClickCancelar = () => {
    this.manejarCancelar();
  }

  setMostrarPassword = () => {
    this.setState(prevState => ({ mostrarPassword: !prevState.mostrarPassword }))
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  render() {
    const { isOpen } = this.props;

    // No mostrar el modal si no está abierto
    if (!isOpen) return null;

    return (
      <div className="component-modal">
        <dialog
          className="modal"
          id="modal-pin"
          ref={this.dialogRef}
          onClose={this.handleClose}
        >
          <PantallaCarga open={this.state.mostrarPantallaCarga} mensaje="Firmando..." />
          <div className="modal-content">
            <div className="modal-body">
              <h3 className="title">{this.props.dialogTitle || 'Ingresar PIN de firma'}</h3>

              {/* Datos del lote (ahora visibles si es necesario) */}
              <div className="datosLotes">
                <p className="form-date"><strong>Confirmar datos:</strong></p>
                <div className="lote-date">
                  Lote: {this.props.loteRecibo} | fecha: {this.props.fecha}
                </div>
                <div className="lote-row">
                  <p className="lote-text"><strong>Concepto: </strong>{this.props.concepto}</p>
                </div>
              </div>

              <p className="form-date">
                <strong>Ingresa el Pin de Firma para firmar el recibo seleccionado:</strong>
              </p>

              {/* Formulario de PIN */}
              <form className="form" noValidate onSubmit={this.handlePinSubmit}>
<div className="form-group" style={{ position: 'relative' }}>
  <input
    id="pin"
    type={this.state.mostrarPassword ? "text" : "password"}
    name="pin"
    className="form-input"
    placeholder=""
    onChange={this.handleInput}
    value={this.state.pin}
    required
  />
  <label htmlFor="pin" className="form-label">Ingresar tu PIN</label>
  <button
    type="button"
    onClick={this.setMostrarPassword}
    className="btn-eye"
    style={{
      position: 'absolute',
      right: '10px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'none',
      border: 'none',
      cursor: 'pointer'
    }}
  >
<span className="material-symbols-outlined"> visibility </span>
  </button>
</div>

                {/* Errores */}
                {this.state.errors.pin && (
                  <div className="error-message">
                    <small style={{ color: "red" }}>{this.state.errors.pin}</small>
                  </div>
                )}

                {this.state.errorPin && (
                  <div className="error-message">
                    <small style={{ color: "red" }}>
                      *Ocurrió un error mientras se recuperaban datos del keystore
                    </small>
                  </div>
                )}

                {/* Footer del modal */}
                <div className="modal-footer">
                  <button
                    className="btn-medium btn-base-outline"
                    type="button"
                    onClick={() => this.handleClose(null)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn-medium btn-primary"
                    type="submit"
                    disabled={!this.state.isLoaded || this.state.mostrarPantallaCarga}
                  >
                    {this.state.mostrarPantallaCarga ? "Firmando..." : "Firmar"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </dialog>
      </div>
    );
    //}

  }
}

export default PinEmpleado;